module.exports = __webpack_public_path__ + "img/admin_wx.fb0293e9.png";